<app-select-mejor-prevision
    (OptionSelectedId)="receiveIdSelect($event)"
    (resetTable)="clearTable($event)"
    (OptionFilters)="receiveIdFilters($event)"
    (changeSelectReset)="reset()"
    [tipoConcepto]="'procesos'"
    (filtersList)="chargeFiltersInTable($event)"
>
</app-select-mejor-prevision>
